import React, { ReactNode, FunctionComponent } from 'react';
import classNames from 'classnames';

export enum CtaBoxColor {
    WHITE,
    HIVES,
}

const mapCtaBoxColorToClassName = {
    [CtaBoxColor.WHITE]: 'cta-box--white',
    [CtaBoxColor.HIVES]: 'cta-box--hives',
};

type CtaBoxProps = {
    children: ReactNode;
    qaRole?: string;
    color?: CtaBoxColor;
};

const CtaBox: FunctionComponent<CtaBoxProps> = ({ children, qaRole, color }) => {
    const className = classNames(
        'cta-box',
        typeof color !== 'undefined' && mapCtaBoxColorToClassName[color]
    );

    return (
        <section className={className} data-qa-role={qaRole || 'cta-box'}>
            <div className="cta-box__inner">{children}</div>
        </section>
    );
};

export default CtaBox;
